// ERP status → design key + per-status palette mapping.
// STATUS_THEME and ERP_TO_DESIGN_KEY now live in constants/statusTheme.js
// so Services can share them; re-exported here to keep existing imports stable.
import * as statuses from "../../../../../../constants/status.constants";
import { STATUS_THEME, ERP_TO_DESIGN_KEY } from "../../../../../../constants/statusTheme";

export { STATUS_THEME, ERP_TO_DESIGN_KEY };

// design key → ERP status
export const DESIGN_KEY_TO_ERP = {
  in_progress: statuses.IN_PROGRESS,
  paused: statuses.PAUSED,
  pending: statuses.ACCEPTED,
  completed: statuses.FINISHED,
  cancelled: statuses.CANCELED
};

// ERP status → bucket field name on WorkerSchedule
export const ERP_TO_BUCKET_FIELD = {
  [statuses.IN_PROGRESS]: "inProgressServices",
  [statuses.PAUSED]: "pausedServices",
  [statuses.ACCEPTED]: "acceptedServices",
  [statuses.FINISHED]: "finishedServices",
  [statuses.CANCELED]: "canceledServices"
};

export const themeForErp = erpStatus => {
  const key = ERP_TO_DESIGN_KEY[erpStatus];
  return STATUS_THEME[key] || STATUS_THEME.pending;
};

// Active statuses count toward conflict detection. Completed/cancelled
// don't conflict with anything because they're past/dead work.
export const ACTIVE_ERP_STATUSES = [
  statuses.IN_PROGRESS,
  statuses.PAUSED,
  statuses.ACCEPTED
];
